import { Registry } from "./registry.js";

const pending = new Map(); // key -> Set<HTMLElement>

function parse(el){
    const json = el.getAttribute("data-props") || el.getAttribute("data-options");
    if (!json) return {};
    try { return JSON.parse(json); } catch { return {}; }
}

async function boot(el){
    if (el.__ctrl || !el.isConnected) return;
    const key = el.getAttribute("data-controller");
    const Klass = Registry.getComponent(key);
    if (!Klass) {
        (pending.get(key) ?? pending.set(key, new Set()).get(key)).add(el);
        return;
    }
    const inst = new Klass(el, parse(el));
    el.__ctrl = inst;
    await inst.init?.();
    inst.connected?.();
}

function scan(root=document){ root.querySelectorAll("[data-controller]").forEach(boot); }

export function startLoader(){
    const start = () => {
        scan(document);
        const mo = new MutationObserver(m=>m.forEach(x=>{
            x.addedNodes?.forEach(n=>{
                if (n.nodeType===1){
                    if (n.hasAttribute?.("data-controller")) boot(n);
                    n.querySelectorAll?.("[data-controller]")?.forEach(boot);
                }
            });
            x.removedNodes?.forEach(n=>{
                if (n.__ctrl) n.__ctrl.destroy();
                n.querySelectorAll?.("[data-controller]")?.forEach(el=>el.__ctrl?.destroy());
            });
        }));
        mo.observe(document.documentElement, { childList:true, subtree:true });
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once:true });
    else start();
}

// Re-hydrieren, wenn später registriert wird
// (kleiner Hook: wir „monkeypatchen“ registerComponent)
const _orig = Registry.registerComponent.bind(Registry);
Registry.registerComponent = (key, Class, opts) => {
    _orig(key, Class, opts);
    const set = pending.get(key);
    if (set) { set.forEach(boot); pending.delete(key); }
};